module.exports = __webpack_public_path__ + "files/d310fe89ae2bf66ddce9e334010bdc49.svg";